var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.666667, 1.280000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "9.138 5.57312 8.19533333 4.66816 6 6.77568 6 0.00064 4.66666667 0.00064 4.66666667 6.77568 2.47133333 4.66816 1.52866667 5.57312 5.33333333 9.2256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,10.24064 L9.33333333,11.52064 L1.33333333,11.52064 L1.33333333,10.24064 L0,10.24064 L0,11.52064 C0,12.22592 0.598,12.80064 1.33333333,12.80064 L9.33333333,12.80064 C10.0693333,12.80064 10.6666667,12.22592 10.6666667,11.52064 L10.6666667,10.24064 L9.33333333,10.24064 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9e4b081066ae5780e6497dd870c0ac63.svg";
export { ForwardRef as ReactComponent };